// Vendor
import { combineReducers } from 'redux'

const createReducer = director => combineReducers({
  ...director.getReducer(),
})

export default createReducer